import { getAllLocales } from '@yi/core';

const localePathSegmentRegex = new RegExp(`^\/*(${getAllLocales().join('|')})\/`);
export const removeLocalePathSegment = (path: string) => path.replace(localePathSegmentRegex, '/');
